import React from 'react';
import { Typography } from '@mui/material';

/**
 * Physician template
 */
export const PhysicianTemplate: React.FC<{ name?: string }> = ({ name }) => {
  return <Typography variant="body2">{name || '-'}</Typography>;
};

export default PhysicianTemplate;
